<template>
  <v-container style="overflow-y: auto;" class="fill-height align-start" fluid>
    <v-card width="100%" class="mx-auto">
      <v-toolbar v-if="!loading" flat color="primary" dark>
        <v-toolbar-title>{{ $t('Invoice.Invoice Detail') }}</v-toolbar-title>
      </v-toolbar>
      <Loading v-else class="mx-auto" />
      <Photo v-if="fileName" :image="'/api/uploads/' + fileName" :pdf="fileName.toLowerCase().endsWith('.pdf')" />

      <basic-information />
      <v-row>
        <v-col class="d-flex justify-center">
          <v-btn x-large @click="$router.go(-1)">
            {{ $t('Invoice.Go Back') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>

import ApiRepository from "../repositories/ApiRepository";
import Loading from "../components/Loading";
import Constants from "../../constants";
import basicInformation from "../components/invoiceInformation";
import Photo from "../components/InvoiceResizeImage";

import moment from "moment";
export default {
    name: "Invoice",
    components: {Loading, basicInformation, Photo},
    data () {
        return {
            loading: true,
            invoice: null,
            canFactor: null,
            files: [],
            items: [],
            select: null,
            heightImage: 400,
            widthImage: 350,
            fileName: null,
            blockchain: {
                link: null,
                date: null,
                amount: null,
                status: null,
            },
            myInvoice: true
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            if (this.$route.params.id) {
                this.$data.loading = true;
                ApiRepository.getInvoiceById(this.$route.params.id)
                    .then((res) => {
                        if (res.data.invoice) {
                            this.invoice = res.data.invoice;
                            if (this.$user) {
                                res.data.invoice.receiver ? this.myInvoice = res.data.invoice.receiver._id === this.$user._id : "";
                                this.invoice.receiver && this.invoice.payer ? this.canFactor = this.$user.cif !== this.invoice.payer.cif && this.$user.cif !== this.invoice.receiver.cif : "";
                            }
                            
                            this.files = res.data.files;
                            if (this.files.length > 0 || (this.files.length === 1 && this.files[0].originalName !== null)) {
                                this.select = {name: this.files[0].originalName};
                                this.fileName = this.select.name;
                            }
                            ApiRepository.getFilename(this.invoice._id)
                                .then((res) => {
                                    this.fileName = res.data.fileName;
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                            for (let i = 0; i < this.files.length; i++) {
                                this.items[i] = {name: this.files[i].originalName};
                            }
                            if (res.data.invoice.hash) {
                                this.blockchain.link = Constants.BLOCKCHAIN_URL + res.data.invoice.hash;
                                ApiRepository.getInvoiceSC(res.data.invoice._id)
                                    .then(res => {
                                        this.blockchain.date = res.data.date;
                                        this.blockchain.amount = res.data.amount + " " + "€";
                                        this.blockchain.status = res.data.status;
                                        switch (this.blockchainStatus) {
                                        case Constants.INVOICE.STATUS_CREATED:
                                            this.blockchainStatus = this.$t('InvoiceStatus.Created');
                                            break;
                                        case Constants.INVOICE.STATUS_COMPENSATED:
                                            this.blockchainStatus = this.$t('InvoiceStatus.Compensated');
                                            break;
                                        case Constants.INVOICE.STATUS_PAYED:
                                            this.blockchainStatus = this.$t('InvoiceStatus.Payed');
                                            break;
                                        case Constants.INVOICE.STATUS_PENDING:
                                            this.blockchainStatus = this.$t('InvoiceStatus.Pending');
                                            break;
                                        case Constants.INVOICE.STATUS_TEMPORARY:
                                            this.blockchainStatus = this.$t('InvoiceStatus.Temporary');
                                            break;
                                        default:
                                            this.blockchainStatus = this.$t('InvoiceStatus.Unknown');
                                            break;
                                        }
                                        this.blockchain.date = moment(this.blockchain.date).format("DD-MM-YYYY ");
                                    })
                                    .catch((err) => {
                                        console.log(this.$t("InvoiceStatus.ERROR: Cannot get blockChain data") + err);
                                    });
                            }
                        }
                    })
                    .finally(() => {
                        this.$data.loading = false;
                    });
            } else {
                this.$data.loading = false;
            }
        },
        setSizes ( ) {
            const img = this.$refs.previewImg;

            if (img) {
                const ratio = img.naturalWidth / img.naturalHeight;
                let width = img.clientHeight * ratio;
                let height = img.clientHeight;
                if (width > img.clientWidth) {
                    width = img.clientWidth;
                    height = img.clientWidth / ratio;
                }
                this.widthImage = (width * 400) / 450;
                this.heightImage = height;
            }
        },
        payInvoice () {
            ApiRepository.invoicePayed(this.invoice._id)
                .then(response => {
                    if (response.data) {
                        this.$root.$emit('show-snackbar', {message: this.$t('Invoice payed successfully!')});
                        this.invoice.status = Constants.INVOICE.STATUS_PAYED;
                    }
                })
                .catch(() => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error paying invoice'), color: "error"});
                });
        }
    }
};
</script>

<style scoped>


</style>
